var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.background)?_c('div',{staticClass:"image",style:(_vm.style)}):_c('img',{staticClass:"image",attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }